import { SxProps, Theme } from '@mui/material'

import rem from '~/utils/ui'

const getButtonStyles = (theme: Theme): SxProps<Theme> => ({
  borderRadius: rem(8),
  fontSize: rem(14),
  width: 'auto',
  height: 'auto',
  minWidth: 'initial',
  minHeight: 'initial',
  maxHeight: rem(40),
  '@media (min-width: 0px)': {
    paddingInline: rem(16),
    paddingBlock: rem(8),
  },
  '.MuiButton-startIcon': {
    marginRight: { xxxs: 0, md: rem(8) },
  },
  '.MuiButton-endIcon': {
    marginLeft: { xxxs: 0, md: rem(8) },
  },
  [theme.breakpoints.down('md')]: {
    border: 'none',
    ':hover': {
      border: 'none',
    },
    '&:disabled': {
      border: 'none',
    },
  },
})

export const BUTTON_TEXT_STYLES: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: rem(14),
  display: { xxxs: 'none', md: 'block' },
}

export default getButtonStyles
